import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

let horizontalSections = gsap.utils.toArray(".fullscreen__horizontal-scolling");

horizontalSections.forEach((container) => {
  let sections = container.querySelectorAll(".panel");

  // Set the container width dynamically
  container.style.width = `${sections.length * 100}vw`;

  // Set each panel to full screen width
  sections.forEach((section) => {
    section.style.width = `${window.innerWidth}px`;
    section.style.flex = "0 0 100vw";
  });

  // Get total scroll width
  const totalScroll = container.scrollWidth - window.innerWidth;

  gsap.to(container, {
    x: () => `-${totalScroll}px`,
    ease: "none",
    scrollTrigger: {
      trigger: container,
      pin: true,
      scrub: 1,
      anticipatePin: 1,
      end: () => `+=${totalScroll}`,
    },
  });
});
